import React from 'react'
import { Field } from 'redux-form'
import WrappedInput from '../../Shared/Forms/WrappedInput'

export default function MongoDB() {
  return (
    <>
      <Field
        autoComplete="off"
        name="connectionUrl"
        component={WrappedInput}
        label="Connection URL"
        placeholder="mongodb://hostname:3006/dbname"
      />
      <Field
        autoComplete="off"
        name="name"
        component={WrappedInput}
        label="Nickname"
        placehlolder="MongoDB"
      />
    </>
  )
}
